// Attribution d'acquisition PRIVACY-FIRST (chantier Acquisition/Conversion,
// mandat Lucas 09/08/2026). Répond à « d'où viennent les utilisateurs qui
// deviennent actifs ? » avec le STRICT minimum :
//   - first-touch uniquement (on ne réécrit jamais une source déjà capturée) ;
//   - utm_source / utm_medium / utm_campaign / utm_content (si présents) ;
//   - à défaut, le HOSTNAME du referrer externe (jamais le chemin ni la query) ;
//   - AUCUNE IP, aucun fingerprinting, aucun tracker tiers, aucun cookie ;
//   - la donnée vit en localStorage jusqu'à l'inscription, est rattachée au
//     compte (user.acquisition) puis PURGÉE localement. Visiteur qui ne
//     s'inscrit jamais → la donnée reste chez lui et n'est jamais transmise.
// Minimisation CNIL : finalité unique (mesure d'acquisition), durée = vie du
// compte (supprimée avec lui). Doc : docs/ACQUISITION-ATTRIBUTION.md.

const KEY = "gively_acq_v1";
const MAX = 80;

const _clean = (v) => (typeof v === "string" ? v.slice(0, MAX) : undefined);

export function captureAcquisition() {
  try {
    if (localStorage.getItem(KEY)) return; // first-touch : jamais écrasé
    const p = new URLSearchParams(window.location.search);
    const acq = {
      source: _clean(p.get("utm_source")),
      medium: _clean(p.get("utm_medium")),
      campaign: _clean(p.get("utm_campaign")),
      content: _clean(p.get("utm_content")),
      landed_at: new Date().toISOString(),
    };
    if (!acq.source) {
      // Pas d'UTM : hostname du referrer EXTERNE seul (google.com, facebook…).
      try {
        const ref = document.referrer ? new URL(document.referrer) : null;
        if (ref && ref.hostname && ref.hostname !== window.location.hostname) {
          acq.referrer_host = _clean(ref.hostname);
        }
      } catch (_) { /* referrer invalide : on ignore */ }
      if (!acq.referrer_host) return; // accès direct sans UTM : rien à retenir
    }
    Object.keys(acq).forEach((k) => acq[k] === undefined && delete acq[k]);
    localStorage.setItem(KEY, JSON.stringify(acq));
  } catch (_) { /* jamais bloquant */ }
}

export function getAcquisition() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) { return null; }
}

export function clearAcquisition() {
  try { localStorage.removeItem(KEY); } catch (_) { /* noop */ }
}

// 10/10/2026 (audit d'acquisition, lot G) — une inscription par Google, Apple ou
// Microsoft ne passe pas par `register()` : sa provenance restait en localStorage
// et n'était jamais rattachée. Au premier `/auth/me` réussi, on l'envoie UNE fois
// à POST /auth/attribution (le serveur n'écrit que sur un compte de moins de 24 h
// sans attribution) puis on la purge. Jamais bloquant.
export async function rattacherAttribution(post) {
  const acq = getAcquisition();
  if (!acq) return;
  try {
    await post("/auth/attribution", { acquisition: acq });
  } catch (_) { /* une attribution manquée ne bloque rien */ } finally {
    clearAcquisition();
  }
}

